import React from "react";

import { Button, Grid } from "@mui/material";
import Container from "@mui/material/Container";
import Modal from "@mui/material/Modal";

import settings from "../../Images/settings.png";
import timer from "../../Images/timer.png";
import BackArrow from "../../Images/backarrow.png";
import plus from "../../Images/plus.png";
import empty from "../../Images/empty.png";

import { Link } from "react-router-dom";
import { AiOutlineDown } from "react-icons/ai";

import Navbar from "../Navbar/Index";
import Footer from "../Footer/Index";
import Minumum from "../../Components/Minmium/Minumum";
import TokensDialogOne from "../../Components/Dialogs/TokensDialogOne";
import TokensDialogTwo from "../../Components/Dialogs/TokensDialogTwo";

const Addliquidity = () => {
  // for dialog
  const [opendialog, setOpendialog] = React.useState(false);
  const [useSelectedValue, setSelectedValue] =
    React.useState("Select Currency");
  const [useSelectedImg, setSelectedImg] = React.useState(empty);

  const handleClickOpen = () => {
    setOpendialog(true);
  };

  const handleListItemClick = (value) => {
    setOpendialog(false);
    setSelectedImg(value.logoURI);
    setSelectedValue(value.symbol);
  };
  // for dialog

  // for dialog2
  const [opendialog2, setOpendialog2] = React.useState(false);
  const [useSelectedValue2, setSelectedValue2] =
    React.useState("Select Currency");
  const [useSelectedImg2, setSelectedImg2] = React.useState(empty);

  const [useFirstVal, setFirstVal] = React.useState();
  const [useSecondVal, setSecondVal] = React.useState();

  const [useInputSlipage, setInputSlipage] = React.useState("2.0");

  const handleClickOpendialog2 = () => {
    setOpendialog2(true);
  };

  const handleListItemClick2 = (value2) => {
    setOpendialog2(false);
    setSelectedImg2(value2.logoURI);
    setSelectedValue2(value2.symbol);
  };

  // for dialog2
  const [showResults, setShowResults] = React.useState(false);
  const firstInput = (event) => {
    const val = event.target.value;
    setFirstVal(val);
    setShowResults(true);
  };
  const SecondInput = (event) => {
    const val = event.target.value;
    setSecondVal(val);
    setShowResults(true);
  };
  const handleSlipage = (event) => setInputSlipage(event.target.value);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openrec, setOpenrec] = React.useState(false);
  const handleOpenrec = () => setOpenrec(true);
  const handleCloserec = () => setOpenrec(false);

  return (
    <div>
      <Container>
        <Navbar />
        <div className="forheight">
          <Grid container justifyContent="center">
            <Grid xs={12} sm={11} md={6} className="py-5">
              <div className=" pt-sm-3 d-flex justify-content-center">
                <div className="Ray---Connectpage---Card">
                  <div className="px-3 pt-3 Ray---Connect---Button---border">
                    <Link to="/liquidity">
                      <img
                        className="Ray---Connect---Modal---Addliquidity---BackArrowbutton"
                        src={BackArrow}
                        alt="back"
                      />
                    </Link>
                    <div className="Ray__Connect__Exchange ">
                      Add Liquidity
                      <p className="Ray---connect---swap">
                        Add Liquidity To Receive LP Tokens
                      </p>
                    </div>

                    <div className="Ray__Connect__Icons pt-sm-3">
                      <img onClick={handleOpen} src={settings} alt="settings" />
                      <img
                        className="ml-2"
                        onClick={handleOpenrec}
                        alt="timer"
                        src={timer}
                      />
                    </div>
                  </div>
                  <TokensDialogOne
                    open={opendialog}
                    onClose={handleListItemClick}
                    disabling={useSelectedValue}
                  />
                  <div className=" p-3">
                    <div className="inputfield">
                      <input
                        onChange={firstInput}
                        className="Ray---Connect---Modal---SelectToken---Fieldforsearchtest"
                        type="number"
                        placeholder="0.00"
                        value={useFirstVal}
                      />
                      <a
                        className="Ray---Addliq---alink"
                        onClick={handleClickOpen}
                      >
                        <img
                          className="Ray---Exchange---Dialoglogo"
                          src={useSelectedImg}
                        />
                        {useSelectedValue}

                        <span style={{ padding: "0px 0px 0px 8px" }}>
                          <AiOutlineDown />
                        </span>
                      </a>
                    </div>
                    <div className=" Ray---Connect---Swapbutton">
                      <img src={plus} alt="" />
                    </div>
                    <TokensDialogTwo
                      opendialog2={opendialog2}
                      onClosedialog2={handleListItemClick2}
                      disablingtoken={useSelectedValue2}
                    />
                    <div className="inputfield">
                      <input
                        onChange={SecondInput}
                        className="Ray---Connect---Modal---SelectToken---Fieldforsearchtest"
                        type="number"
                        placeholder="0.00"
                        value={useSecondVal}
                      />
                      <a
                        className="Ray---Addliq---alink"
                        onClick={handleClickOpendialog2}
                      >
                        <img
                          className="Ray---Exchange---Dialoglogo"
                          src={useSelectedImg2}
                        />
                        {useSelectedValue2}
                        <span style={{ padding: "0px 0px 0px 8px" }}>
                          <AiOutlineDown />
                        </span>
                      </a>
                    </div>
                    <Button
                      disabled={true}
                      className="mt-4 Rey---Connect---SwapButton"
                    >
                      Invalid Pair
                    </Button>
                    {showResults ? <Minumum /> : null}
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        {/* Modal for settings starts here------------------------------------------ */}

        <Modal
          className="Modal"
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="mt-5 pt-sm-5 d-flex justify-content-center"
            style={{ outline: "unset" }}
          >
            <div className="Ray---Connectpage---Card m-2 p-4">
              <h4
                style={{ color: "white" }}
                className="Rey---Head---card---ModalSettingHead"
              >
                Setting
                <button
                  className="L__Modal__CloseBtn"
                  onClick={() => handleClose(false)}
                >
                  X
                </button>
              </h4>
              <div
                className="Ray---Connect---Modal---fromto"
                style={{ color: "white" }}
              >
                <p>Slipage Tolerance?</p>
                <div className="Ray---settings---inputauto">
                  <Button className="Rey---settings---autobutton">auto</Button>

                  <label htmlFor="text"></label>
                  <input
                    onChange={handleSlipage}
                    className="Ray---Connect---Modal---Text "
                    type="number"
                    placeholder="2.00%"
                    value={useInputSlipage}
                  />
                </div>
                <p className="mt-2 pb-2">Transaction Deadline?</p>
                <p className="Ray---Connect---Modal---TextTransaction">20</p>
                <p className="Ray---Connect---Modal---textmint">Minutes</p>
              </div>
            </div>
          </div>
        </Modal>

        {/* Modal for recent starts here -----------------------------------------*/}
        <Modal
          className="Modal"
          open={openrec}
          onCloserec={handleCloserec}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="mt-5 pt-sm-5 d-flex justify-content-center"
            style={{ outline: "unset" }}
          >
            <div className="Ray---Connectpage---Card m-2 p-4">
              <h4
                style={{ color: "white" }}
                className="Rey---Head---card---ModalSettingHead"
              >
                Recent Transactions
                <button
                  className="L__Modal__CloseBtn"
                  onClick={() => handleCloserec(false)}
                >
                  X
                </button>
              </h4>
              <div
                style={{ color: "white" }}
                className="Rey---Head---card---ModalRecentboxcolor"
              >
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <h6>Send</h6>
                  <h6>-50 Gxs</h6>
                </div>
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <span>Jan 10 To: 0X024...1E61</span>
                  <span> +50 Gxs</span>
                </div>
              </div>
              <div
                style={{ color: "white" }}
                className="Rey---Head---card---ModalRecent2ndboxcolor"
              >
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <h6>Recieved</h6>
                  <h6> +500 Gxs</h6>
                </div>
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <span>Jan 10 To: 0X024...1E61</span>
                  <span> +500 Gxs</span>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        {/* modal for recent ends ------------------------------------------*/}

        <Footer />
      </Container>
    </div>
  );
};
export default Addliquidity;
